export const isProduction = import.meta.env.MODE === 'production';
// export const isProduction = process.env.NODE_ENV === 'production';

export const SMART_DEBRIEF_API = import.meta.env.VITE_SMART_DEBRIEF_API || 'http://localhost:3000';